// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"89":"Citas","107":"Envios","250":"Documentos","430":"Inicio","585":"Pacientes","668":"Avisos"}[chunkId] + "." + {"89":"d24eb310","107":"189a34c3","250":"401f11b7","430":"6196ad8e","585":"26df61db","668":"7b4810be"}[chunkId] + ".css";
};